/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import React from 'react';
import { DEFAULT_LANGUAGE, type SupportedLanguage } from '../../utils/language.utils';
import { useTranslation } from '../../hooks/useTranslation';
import { ModalFormFooterView } from './ModalFormFooterView';

// Satellite dictionaries and tenant overlays may omit this shared label.
// A view-only form must retain a visible, accessible close action.
const CLOSE_LABELS: Record<SupportedLanguage, string> = {
  tr: 'Kapat', en: 'Close', ar: 'إغلاق', de: 'Schließen', fr: 'Fermer',
  es: 'Cerrar', it: 'Chiudi', ru: 'Закрыть', zh: '关闭', ja: '閉じる',
};

export interface ModalFormFooterProps {
  language?: SupportedLanguage;
  saving?: boolean;
  /** Form önkoşulları sağlanmadığında yalnız submit eylemini devre dışı bırakır. */
  submitDisabled?: boolean;
  formId?: string;
  onCancel: () => void;
  /** Salt okunur mod: Kapat; onEdit varsa Düzenle. */
  viewOnly?: boolean;
  /** Kaydedilmiş kaydı İncele modundan Düzenle moduna geçirir. */
  onEdit?: () => void;
  /** Native form kullanmayan editörlerin Kaydet eylemi. */
  onSubmit?: () => void;
  /** Guided Learning için kararlı, selector içermeyen submit eylemi kimliği. */
  submitLearningTargetId?: string;
  /** Domain action name, retaining the shared footer's placement and states. */
  submitLabel?: string;
}

export const ModalFormFooter: React.FC<ModalFormFooterProps> = ({
  language = DEFAULT_LANGUAGE,
  saving = false,
  submitDisabled = false,
  formId,
  onCancel,
  viewOnly = false,
  onEdit,
  onSubmit,
  submitLearningTargetId,
  submitLabel,
}) => {
  const t = useTranslation(language);
  const closeLabel = typeof t.common?.close === 'string' && t.common.close.trim()
    ? t.common.close
    : CLOSE_LABELS[language] ?? CLOSE_LABELS[DEFAULT_LANGUAGE];
  return <ModalFormFooterView
    onCancel={onCancel} saving={saving} submitDisabled={submitDisabled} formId={formId}
    viewOnly={viewOnly} onEdit={onEdit} onSubmit={onSubmit} submitLearningTargetId={submitLearningTargetId}
    labels={{ cancel: t.common.cancel, save: submitLabel?.trim() || t.common.save, saving: t.common.saving, close: closeLabel, edit: t.common.edit }}
  />;
};
